// extracted by mini-css-extract-plugin
module.exports = {"imgApp":"src-components-UI-AppImage-AppImage-module__imgApp--n_LBk","small":"src-components-UI-AppImage-AppImage-module__small--3i9bo"};